<template>	
	<div v-editable="blok" class="text-block w-full pt-4">
		<h4 v-if="blok.title" class="text-sm">{{ blok.title }}</h4>
		<a v-if="blok.link?.url" class="text-sm text-[#726387] hover:text-[#d7b8ff] break-words transition-colors duration-300" 
		:alt="blok.link.title ?? $t('blog.reference_link', {title: blok.title})"
		:rel="'noopener noreferrer '+(blok.link.rel || '')"
		:href="blok.link.url">{{blok.link.url}}</a>
	</div>
</template>
 
<script setup>
defineProps({ blok: Object })
</script>